import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
import axios from 'axios'
const api = '/api/chat/'
const get = axios.get
const post = axios.post

const handleRequest = async (request: Promise<any>, thunkAPI: any) => {
  try {
    const res = await request
    return res.data
  } catch (error: any) {
    return thunkAPI.rejectWithValue(error.response.data)
  }
}

export const GetChat = createAsyncThunk(
  `list`,
  ({rec_id, model_type}: {rec_id: string; model_type: string}, thunkAPI) =>
    handleRequest(get(`${api}list${rec_id}/${model_type}`), thunkAPI)
)

export const createChat = createAsyncThunk(`chat-create`, (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store`, data), thunkAPI)
)

export const AdminContacts = createAsyncThunk(`admin-contacts`, (id: string, thunkAPI) =>
  handleRequest(get(`${api}admin-contacts/${id}`), thunkAPI)
)

export const UserMsgCount = createAsyncThunk(`count-messages`, (_, thunkAPI) =>
  handleRequest(get(`${api}user-msg-count`), thunkAPI)
)

export const ContactList = createAsyncThunk(`contact-list`, (_, thunkAPI) =>
  handleRequest(get(`${api}contact-list`), thunkAPI)
)

export const MessageRead = createAsyncThunk(`read-msg`, (id: string, thunkAPI) =>
  handleRequest(get(`${api}message-read/${id}`), thunkAPI)
)

export const StudentContacts = createAsyncThunk(`student-contacts`, (id: string, thunkAPI) =>
  handleRequest(get(`${api}student-contacts/${id}`), thunkAPI)
)

export const LecturerContacts = createAsyncThunk(`lecturer-contacts`, (id: string, thunkAPI) =>
  handleRequest(get(`${api}lecturer-contacts/${id}`), thunkAPI)
)

export const PendingMessages = createAsyncThunk(`pending-msg`, (id: any, thunkAPI) =>
  handleRequest(get(`${api}ending-message/${id}`), thunkAPI)
)

export const CourseMsg = createAsyncThunk(`course-chats`, (id: any, thunkAPI) =>
  handleRequest(get(`${api}course-chats/${id}`), thunkAPI)
)

export const CreateCourseMsg = createAsyncThunk(`store-cm`, (data: {}, thunkAPI) =>
  handleRequest(post(`${api}store-cm`, data), thunkAPI)
)

type chatState = {
  records: any
  errors: any
  msgCount: any
  contactsList: any
}

const initialState: chatState = {
  records: {
    data: [],
  },
  errors: '',
  msgCount: '',
  contactsList: [],
}

export const chatSlice = createSlice({
  name: 'chat',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder
      .addCase(UserMsgCount.fulfilled, (state, action: PayloadAction<any>) => {
        state.msgCount = action.payload
      })
      .addCase(ContactList.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload
      })
      .addCase(PendingMessages.fulfilled, (state, action: PayloadAction<any>) => {
        state.contactsList = action.payload.contacts
        state.msgCount = action.payload.total_unread
      })
  },
})

export const {reset} = chatSlice.actions
export default chatSlice.reducer
